import http from './http'

/**
 * 图库列表（unite49）
 * @param {number} lotteryType 香港 1，澳门 2
 */
export function fetchUnite49PictureList(site,lotteryType) {
  return http.get('/api/pictures/unite49/list', {
    params: { site,lotteryType }
  })
}
